let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dzONu")).then(() => parcelRequire('kTqjh'));